import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-yellow bg-white" data-id="element-94" data-mp="9lbg511q9bdl">
      <p className="bg-brand-blue px-3 py-1.5 text-center font-sub text-base font-bold leading-tight text-white sm:text-lg" data-id="element-95" data-mp="4mi297ij3icw">
        ¡Pequeñas manos, <span className="text-brand-yellow" data-id="element-96" data-mp="128phrcgdev41">grandes inventos!</span>
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-97" data-mp="xbpawzbp5obv">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[1.85rem] leading-[1.05] text-brand-navy sm:text-5xl" data-id="element-98" data-mp="sai5h6x1118d">
          El sistema completo para{' '}
          <span className="bg-brand-yellow px-1" data-id="element-99" data-mp="3825yir8x69lw">despertar la creatividad</span>,{' '}
          <span className="text-brand-orange" data-id="element-100" data-mp="3j7zf9iqmlsgo">aprender ciencia</span> y{' '}
          <span className="text-brand-blue" data-id="element-101" data-mp="3j6odtpknkwsq">construir inventos increíbles</span>{' '}
          desde casa.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-102" data-mp="39ausbgoyhsyt">
          Ayudá a tus hijos a descubrir cómo funcionan las cosas, desarrollar su
          imaginación y crear proyectos con cartón, materiales reciclados y
          circuitos sencillos,{' '}
          <strong className="font-semibold text-brand-navy" data-id="element-103" data-mp="2qlocq2jglhh8">
            sin perderte entre cientos de videos, actividades e ideas sueltas.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg bg-brand-navy px-3 py-1.5 font-sans text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-104" data-mp="2hkglg4fd1gwn">
          {PRODUCT_NAME} · <span className="text-brand-yellow" data-id="element-105" data-mp="s332b5sqsatu">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-brand-orange bg-brand-cream" data-id="element-106" data-mp="nb1kl4ct1rwf">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-107" data-mp="1azkvlrn8ois7" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-semibold text-brand-muted sm:text-sm" data-id="element-108" data-mp="111okv0y7rpum">
          {PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos
        </p>

        <div className="mt-2.5" data-id="element-109" data-mp="3lsp1x9cpsbcb">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-110" data-mp="3lu02l0av52z7">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-brand-muted" data-id="element-111" data-mp="3hpse948bhp1i">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}